import { asteroids } from '../entities/asteroids-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { distance } from '../lib/distance-sidecar'
import { scene } from '../main/scene-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask, ITaskType } from './jobs'
import { jobs } from './jobs-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { tilesShip } from '../tiles/tilesShip-sidecar'
import { blueprints } from '../blueprints/blueprints-sidecar'
import { common } from '../main/common-sidecar'
import { ICargoType } from '../entities/cargoesData'
import { rando } from '../lib/rando-sidecar'

const type: ITaskType = 'mine'
export function createTask_mine(i: number, j: number): ITask {
  return jobs._createTask(i, j, type, {})
}

export function runTask_mine(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, type)
  let m = jobLogger.assertReserved(job)

  let ctx = scene.getContext()

  let bp = jobLogger.assertBlueprint(job)

  // Are we at the right spot?
  if (!distance.isNextToIJ(m, task)) {
    return jobLogger.failTask(job, task, 'not next to spot')
  }

  let std = tilesDataShip.getStandard()
  let t = tileMapShip.getTile(ctx.mapShip, task.i, task.j)
  if (!t) {
    return jobLogger.failTask(job, task, 'tile missing')
  }

  let asteroidHere = asteroids.findAtSpot(task.i, task.j, (c) => true)
  // Cargo went missing
  if (!asteroidHere && t.dataFloor !== std.asteroid) {
    return jobLogger.failTask(job, task, 'asteroid/asteroid tile missing')
  }

  if (!distance.isNextToIJ(m, task)) {
    return jobLogger.failTask(job, task, 'not next to task')
  }

  // increase progress
  task.progress += common.getUpdateDeltaScaled()
  if (task.progress < 5) {
    blueprints.setProgress(bp, task.progress, 5)
    return // Wait
  }

  if (asteroidHere) {
    let car = cargoes.create(asteroidHere.data.cargoType)
    cargoes.moveToTile(car, ctx.mapShip, m.i, m.j)
    monsters.pickupCargo(m, car)
    asteroidHere.supplyLeft--
    if (asteroidHere.supplyLeft <= 0) {
      blueprints.kill(bp)
      asteroids.kill(asteroidHere)
    }
  } else {
    let cargoType: ICargoType = 'error'

    if (t.asteroidType === 'ice') {
      cargoType = 'ice'
    }
    if (t.asteroidType === 'iron') {
      cargoType = 'steel'
    }
    if (t.asteroidType === 'rock') {
      if (rando.chance(0.1)) {
        cargoType = 'steel'
      }
    }

    if (cargoType !== 'error') {
      let car = cargoes.create(cargoType)
      cargoes.moveToTile(car, ctx.mapShip, m.i, m.j)
      monsters.pickupCargo(m, car)
    }
    tilesShip.setFloor(t, null)
    blueprints.kill(bp)
  }

  return jobLogger.succeedTask(job, task)
}
